// src/pages/AboutUsPage.jsx
import React from "react";

const AboutUsPage = () => {
  return (
    <div className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-4 max-w-5xl">
        <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 text-center mb-12 font-inter drop-shadow-md">
          About Insperity Games - Crafting Digital Adventures
        </h1>

        <section className="bg-white p-10 rounded-3xl shadow-xl mb-12 border-l-4 border-blue-500">
          <p className="text-gray-700 text-xl leading-relaxed mb-8">
            At Insperity Games, we are a passionate team of developers, artists,
            and designers united by a shared love for gaming and a vision to
            create memorable interactive experiences. Founded with the belief
            that games should be both entertaining and inspiring, we pour our
            creativity and technical expertise into every project.
          </p>
          <p className="text-gray-700 text-xl leading-relaxed">
            Our journey began with a simple goal: to develop mobile games that
            resonate with players across all platforms – Android, iOS, and
            Amazon. We focus on innovative gameplay mechanics, intuitive user
            interfaces, and visually appealing designs that provide hours of
            enjoyment. We are committed to continuous improvement, listening to
            our player community, and pushing the boundaries of mobile game
            development. Thank you for being a part of the Insperity Games
            journey.
          </p>
        </section>

        <section className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-12">
          <div className="mission-vision-gradient-blue p-10 rounded-3xl shadow-lg flex flex-col items-center text-center transform hover:scale-105 transition-transform duration-300">
            <i className="fas fa-bullseye text-6xl text-blue-700 mb-5 animate-pulse"></i>
            <h2 className="text-3xl font-bold text-blue-800 mb-4 font-inter">
              Our Mission
            </h2>
            <p className="text-gray-800 leading-relaxed text-lg">
              To develop engaging, high-quality mobile games that bring joy and
              entertainment to players around the globe.
            </p>
          </div>
          <div className="mission-vision-gradient-teal p-10 rounded-3xl shadow-lg flex flex-col items-center text-center transform hover:scale-105 transition-transform duration-300">
            <i className="fas fa-infinity text-6xl text-teal-700 mb-5 animate-pulse delay-100"></i>
            <h2 className="text-3xl font-bold text-teal-800 mb-4 font-inter">
              Our Vision
            </h2>
            <p className="text-gray-800 leading-relaxed text-lg">
              To be a recognized independent game studio, known for creativity,
              player-centric design, and technical excellence.
            </p>
          </div>
        </section>

        <section className="bg-white p-10 rounded-3xl shadow-xl border-r-4 border-teal-500">
          <h2 className="text-4xl font-bold text-gray-800 text-center mb-8 font-inter">
            Our Key Values
          </h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-xl">
            <li className="flex flex-col items-center text-center p-4 bg-gray-50 rounded-xl shadow-inner hover:bg-blue-50 transition-colors duration-200">
              <span className="text-blue-600 text-5xl mb-3">
                <i className="fas fa-lightbulb"></i>
              </span>
              <strong className="text-gray-900 font-semibold mb-1">
                Innovation
              </strong>
              <p className="text-gray-700 text-base">
                Constantly exploring new ideas and technologies.
              </p>
            </li>
            <li className="flex flex-col items-center text-center p-4 bg-gray-50 rounded-xl shadow-inner hover:bg-green-50 transition-colors duration-200">
              <span className="text-green-600 text-5xl mb-3">
                <i className="fas fa-star"></i>
              </span>
              <strong className="text-gray-900 font-semibold mb-1">
                Quality
              </strong>
              <p className="text-gray-700 text-base">
                Delivering polished and enjoyable gaming experiences.
              </p>
            </li>
            <li className="flex flex-col items-center text-center p-4 bg-gray-50 rounded-xl shadow-inner hover:bg-purple-50 transition-colors duration-200">
              <span className="text-purple-600 text-5xl mb-3">
                <i className="fas fa-users"></i>
              </span>
              <strong className="text-gray-900 font-semibold mb-1">
                Community
              </strong>
              <p className="text-gray-700 text-base">
                Valuing player feedback and building a supportive environment.
              </p>
            </li>
            <li className="flex flex-col items-center text-center p-4 bg-gray-50 rounded-xl shadow-inner hover:bg-red-50 transition-colors duration-200">
              <span className="text-red-600 text-5xl mb-3">
                <i className="fas fa-heart"></i>
              </span>
              <strong className="text-gray-900 font-semibold mb-1">
                Passion
              </strong>
              <p className="text-gray-700 text-base">
                Driven by our love for games and the art of creation.
              </p>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default AboutUsPage;
